import { render, staticRenderFns } from "./mail-template-send.vue?vue&type=template&id=833059a4"
import script from "./mail-template-send.vue?vue&type=script&lang=js"
export * from "./mail-template-send.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports